import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  withStyles,
} from '@material-ui/core'

import Modal from './Modal'
import InputText from './InputText'


const styles = () => ({
  root: {},
})


const ModalEditPassword = ({
  open,
  classes,
  onClose,
  onSubmit,
  isLoading,
}) => {
  const [oldPassword, setOldPassword] = useState('')
  const [password, setPassword] = useState('')

  const handleChange = func => e => func(e.target.value)
  const isSubmitable = oldPassword && password
  const handleSubmit = () => onSubmit && onSubmit({ oldPassword, password })

  return (
    <Modal
      open={open}
      onCancel={onClose}
      cancelLabel="Annuler"
      isLoading={isLoading}
      onSubmit={handleSubmit}
      className={classes.root}
      submitLabel="Enregister"
      submitDisabled={!isSubmitable}
      title="Modifier le mot de passe"
    >
      <InputText
        margin
        fullWidth
        type="password"
        name="oldPassword"
        value={oldPassword}
        isLoading={isLoading}
        label="Ancien mot de passe"
        onPressEnter={handleSubmit}
        onChange={handleChange(setOldPassword)}
      />

      <InputText
        margin
        fullWidth
        type="password"
        name="password"
        value={password}
        isLoading={isLoading}
        label="Nouveau mot de passe"
        onPressEnter={handleSubmit}
        onChange={handleChange(setPassword)}
      />
    </Modal>
  )
}

ModalEditPassword.propTypes = {
  open: PropTypes.bool,
  user: PropTypes.object,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(ModalEditPassword)
